import { CloudinaryImg } from "@components/CloudinaryImg";
import { css } from "@emotion/react";

import { ImageFormat } from "@every.org/common/src/helpers/cloudinary";

import { MediaSize, cssForMediaSize } from "src/theme/mediaQueries";

const SIGNUP_IMAGE_CLOUDINARY_ID = "signup_m50ttl";

export const SignUpSideImage = ({ className }: { className?: string }) => {
  return (
    <div
      className={className}
      css={css`
        width: 240px;
        height: auto;

        ${cssForMediaSize({
          min: MediaSize.X_LARGE,
          css: css`
            height: auto;
            max-width: 385px;
            width: 75%;
          `,
        })};
      `}
    >
      <CloudinaryImg
        cloudinaryId={SIGNUP_IMAGE_CLOUDINARY_ID}
        imageFormat={ImageFormat.svg}
        dimensions={{
          height: 456,
          width: 390,
        }}
        alt="Signup image"
      />
    </div>
  );
};
